import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateService {
    public time = new Date();
    public hour: number;
    public timer;

    public timeFormat = 'H:mm';
    public dateLocale = 'de';

    public weekDayTitles = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    constructor() {
    }

    public initTime() {
        this.hour = this.time.getHours();
        this.timer = setInterval(() => {
            this.time = new Date();
            this.hour = this.time.getHours();
        }, 1000);
    }

    public getNumberOfWeek(): number {
        const d = new Date(Date.UTC(this.time.getFullYear(), this.time.getMonth(), this.time.getDate()));
        const dayNum = d.getUTCDay() || 7;
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    }

    public getWeekDayTitle(index) {
        return this.weekDayTitles[index];
    }
}
